import React from 'react';

import moment from 'moment';

import { openModal } from '../../api/modals/actions';
import { cancel, cancelContract, switchContractInterval, previewContractSwitch, restartContract, fetchContract } from '../../api/subscription/actions'
import { fetchUser } from '../../api/user/actions'
import { formatAmount, intervalLabel, intervalAdverb, formatDate, contractStateLabel, billingRunStateLabel, contractExpiry } from './helpers'

let trans = [
  gettext("Billing type"),
  gettext("Total"),
  gettext("Date"),
  gettext("Receipt"),
  gettext("Transactions"),
  gettext("Card holder name"),
  gettext("Card"),
  gettext("Valid until"),
  gettext("trial"),
  gettext("renewal"),
  gettext("Stop renewal"),
  gettext("Subscription is cancelled and expires"),
]


class Subscription extends React.Component {

    constructor(props){
        super(props)
        this.state = {}

        this.cancelSubscription = this.cancelSubscription.bind(this)
        this.cancelContract = this.cancelContract.bind(this)
        this.switchInterval = this.switchInterval.bind(this)
        this.restartContract = this.restartContract.bind(this)
        this.renderBillingLogsTable = this.renderBillingLogsTable.bind(this)
        this.renderBillingRunsTable = this.renderBillingRunsTable.bind(this)
        this.openReceipt = this.openReceipt.bind(this)
        this.getPaymentMethod = this.getPaymentMethod.bind(this)
        this.getContractPaymentMethod = this.getContractPaymentMethod.bind(this)
    }

    cancelSubscription() {
      if (window.confirm(gettext("Are you sure you want to cancel your subscription?"))) {
        Promise.resolve(this.props.dispatch(cancel()))
        .then(() => {
            this.props.dispatch(fetchUser())
        })
      }
    }

    cancelContract() {
      if (window.confirm(gettext("Are you sure you want to cancel your subscription?"))) {
        this.setState({ notice: null })
        this.props.dispatch(cancelContract())
      }
    }

    // Monthly <-> yearly, prorated and effective today. The confirm dialog
    // shows what the backend estimates; the notice afterwards what happened.
    switchInterval(option) {
      let adverb = intervalAdverb(option.interval, option.interval_count)
      let charge = `${formatAmount(option.amount, option.currency)} ${intervalLabel(option.interval, option.interval_count)}`
      this.setState({ notice: null, noticeType: 'success', switching: true })
      previewContractSwitch(option.interval)
      .then(preview => {
        let est = preview.estimate || {}
        let currency = est.currency || option.currency
        let message
        if (est.preview_ok && parseFloat(est.due_now) > 0) {
          message = interpolate(
            gettext("Switch to %s billing? We will charge your card about %s now: %s for the coming period, minus %s for the unused part of your current period. After that you pay %s, next renewal %s."),
            [adverb, formatAmount(est.due_now, currency), formatAmount(est.charge_amount, currency), formatAmount(est.credit_amount, currency), charge, formatDate(est.next_billing_at)])
        } else if (est.preview_ok) {
          message = interpolate(
            gettext("Switch to %s billing? Nothing is charged now: the unused part of your current period, %s, is credited to your account and used for your coming payments. After that you pay %s, next renewal %s."),
            [adverb, formatAmount(est.balance_credit, currency), charge, formatDate(est.next_billing_at)])
        } else {
          message = interpolate(
            gettext("Switch to %s billing? The unused part of your current period is credited and the new price is charged from today. After that you pay %s, next renewal %s."),
            [adverb, charge, formatDate(est.next_billing_at)])
        }
        if (!window.confirm(message)) {
          return null
        }
        return this.props.dispatch(switchContractInterval(option.interval))
      })
      .then(data => {
        if (!data || !data.contract) {
          return
        }
        let result = data.switch || {}
        let currency = (result.option && result.option.currency) || option.currency
        let renewal = formatDate(data.contract.next_billing_at)
        if (result.warning) {
          this.setState({ notice: result.warning, noticeType: 'warning' })
        } else if (result.charge && parseFloat(result.charge.amount) > 0 && result.charge.state === 'succeeded') {
          this.setState({ notice: interpolate(gettext("Done! Your card was charged %s. From now on you pay %s, next renewal %s."),
            [formatAmount(result.charge.amount, result.charge.currency || currency), charge, renewal]) })
        } else if (result.charge && parseFloat(result.charge.amount) > 0) {
          // Áskell processes the run in the background; the receipt follows
          this.setState({ notice: interpolate(gettext("Done! %s will be charged to your card shortly. From now on you pay %s, next renewal %s."),
            [formatAmount(result.charge.amount, result.charge.currency || currency), charge, renewal]) })
        } else if (result.estimate && parseFloat(result.estimate.balance_credit) > 0) {
          this.setState({ notice: interpolate(gettext("Done! %s has been credited to your account and will be used for your coming payments. From now on you pay %s, next renewal %s."),
            [formatAmount(result.estimate.balance_credit, currency), charge, renewal]) })
        } else {
          this.setState({ notice: interpolate(gettext("Done! From now on you pay %s, next renewal %s."), [charge, renewal]) })
        }
        // Show the new charge in the transactions table
        this.props.dispatch(fetchContract())
      })
      .catch(error => {
        this.setState({ notice: (error && error.message) || gettext("Could not change the billing interval. Please try again."), noticeType: 'danger' })
      })
      .then(() => this.setState({ switching: false }))
    }

    restartContract() {
      if (window.confirm(gettext("Resume the renewal of your subscription?"))) {
        this.setState({ notice: null, noticeType: 'success' })
        Promise.resolve(this.props.dispatch(restartContract()))
        .then(data => {
          if (data && data.contract) {
            this.setState({ notice: gettext("Your subscription will renew as before.") })
          }
        })
      }
    }

    openReceipt(transaction){
      this.props.dispatch(openModal("modal-receipt", "scroll", transaction.data))
    }

    renderBillingLogsTable(logs){
      return (
        <table className="table">
          <tr>
            <th>{gettext("Billing type")}</th>
            <th>{gettext("Total")}</th>
            <th>{gettext("Date")}</th>
            <th></th>
          </tr>
          { logs.map((i) => {
            if ((i.billing_log_type == 'renewal' && i.transaction && i.transaction.state === 'settled') || i.billing_log_type == 'trial'){
              return (
                <>
                <tr>
                  <td>{gettext(i.billing_log_type)}</td>
                  { i.billing_log_type == 'renewal' ?
                    <>
                      <td>{i.transaction.amount} {i.transaction.currency}</td>
                      <td>{moment(i.billing_date).format('DD.MM.YYYY')}</td>
                      <td>
                        <a href={`/payments/transactions/${i.transaction.uuid}/receipt/`} target="_blank">{gettext("Receipt")}</a>
                      </td>
                    </>
                    :
                    <>
                      <td>{i.total}</td>
                      <td colSpan="3">{moment(i.billing_date).format('DD.MM.YYYY')}</td>
                    </>
                  }
                </tr>
              </>
              )
            }
          })
          }
        </table>
      )
    }

    // Billing runs of a V2 contract (from /payments/v2/contract/)
    renderBillingRunsTable(runs){
      let rows = runs.filter(run => run.state !== 'canceled')
      if (rows.length === 0) {
        return <p>{gettext("No payments yet.")}</p>
      }
      return (
        <table className="table">
          <thead>
            <tr>
              <th>{gettext("Date")}</th>
              <th>{gettext("Total")}</th>
              <th>{gettext("Status")}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
          { rows.map((run) =>
            <tr key={run.id}>
              <td>{moment(run.last_attempt_at || run.period_start_at || run.created_at).format('DD.MM.YYYY')}</td>
              <td>{formatAmount(run.total_amount, run.currency)}</td>
              <td>{billingRunStateLabel(run.state)}</td>
              <td>
                { run.state === 'succeeded' && run.transaction_uuid &&
                  <a href={`/payments/transactions/${run.transaction_uuid}/receipt/`} target="_blank">{gettext("Receipt")}</a>
                }
              </td>
            </tr>
          )}
          </tbody>
        </table>
      )
    }

    getPaymentMethod(subscription){
      return (
        <>
        { subscription.data && subscription.data.customer &&
          <div>
            <div>{gettext("Card holder name")}: { subscription.data.customer.first_name } { subscription.data.customer.last_name }</div>
            <div>{gettext("Card")}: { subscription.data.customer.payment_method[0].display_info }</div>
            <div>{gettext("Valid until")}: { moment(subscription.data.customer.payment_method[0].valid_until).format("DD.MM.YYYY") }</div>
          </div>
        }
        </>
      )

    }

    getContractPaymentMethod(subscription){
      let methods = (subscription.contract && subscription.contract.paymentMethods) || []
      let method = methods.find(m => m.verified && !m.canceled) || methods[0]
      if (!method) {
        return null
      }
      return (
        <div>
          <div>{gettext("Card")}: { method.display_info }</div>
          { method.valid_until &&
            <div>{gettext("Valid until")}: { moment(method.valid_until).format("DD.MM.YYYY") }</div>
          }
        </div>
      )
    }

    renderContract(contract, subscription) {
      let expiry = contractExpiry(contract)
      let planOptions = (subscription.contract && subscription.contract.planOptions) || []
      let busy = (subscription.contract && subscription.contract.isFetching) || this.state.switching
      return (
        <>
          <p>
            <strong>{ contract.product_name || gettext("Subscription") }</strong>
            { contract.amount !== null && contract.amount !== undefined &&
              <> ({ formatAmount(contract.amount, contract.currency) } { intervalLabel(contract.interval, contract.interval_count) })</>
            }
          </p>
          <p>{gettext("Status")}: { contractStateLabel(contract) }</p>
          { contract.is_active && contract.is_on_trial &&
            <p>{gettext("Trial subscription")}. {gettext("Expires")}: {formatDate(contract.trial_end_at)}</p>
          }
          { contract.is_active && !contract.is_cancelled && contract.next_billing_at &&
            <>
              <p>{gettext("Next renewal")}: {formatDate(contract.next_billing_at)}</p>
              <button className="btn" onClick={this.cancelContract} disabled={subscription.contract.isFetching}>{gettext("Stop renewal")}</button>
            </>
          }
          { contract.is_active && !contract.is_cancelled && contract.next_billing_at && planOptions.length > 0 &&
            <div className="plan-switch">
              { planOptions.map(option =>
                <p key={option.interval}>
                  <button className="btn" onClick={() => this.switchInterval(option)} disabled={busy}>
                    {interpolate(gettext("Switch to %s billing"), [intervalAdverb(option.interval, option.interval_count)])}
                  </button>
                  <span className="plan-switch-price">{formatAmount(option.amount, option.currency)} {intervalLabel(option.interval, option.interval_count)}</span>
                </p>
              )}
            </div>
          }
          { contract.is_active && contract.is_cancelled &&
            <>
              <p>{gettext("Subscription is cancelled and expires")}: {formatDate(expiry)}</p>
              { contract.state === 'active' &&
                <button className="btn" onClick={this.restartContract} disabled={busy}>{gettext("Resume renewal")}</button>
              }
            </>
          }
          { this.state.notice &&
            <div className={`alert alert-${this.state.noticeType || 'success'}`}>{this.state.notice}</div>
          }
          { !contract.is_active &&
            <>
              <p>{gettext("No active subscription")}</p>
              <button className="btn buy-button btn-buy" onClick={() => this.props.dispatch(openModal("modal-subscription"))}>{gettext("Buy subscription")}</button>
            </>
          }
          { subscription.contract.error &&
            <div className="alert alert-danger">{subscription.contract.error}</div>
          }
          <div>{ this.getContractPaymentMethod(subscription) }</div>
          { contract.is_active &&
            <button className="btn mt-5" onClick={() => this.props.dispatch(openModal("modal-subscription"))}>{gettext('Update credit card')}</button>
          }
        </>
      )
    }

    render() {
        const { subscription, user } = this.props
        // A user can have a legacy PlanVariant subscription or a V2 contract.
        // Prefer whichever currently grants access, then the V2 contract.
        let legacy = user.subscription
        let legacyActive = legacy && user.hasSubscription && (legacy.active || moment(legacy.active_until) > moment())
        let contract = user.contract
        let showContract = contract && (contract.is_active || !legacyActive)
        // Receipts from the legacy subscription this contract replaced (or an older one)
        let legacyLogs = (subscription.data && subscription.data.billing_logs) || []
        let legacyHistory = legacyLogs.some(i => (i.billing_log_type == 'renewal' && i.transaction && i.transaction.state === 'settled') || i.billing_log_type == 'trial')

        return (
            <>
            <div className="row justify-content-center subscription">
                <div className="col-16 col-sm-14 col-md-12 col-lg-8">
                    <h2>{gettext("My subscription")}</h2>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-16 col-md-6 col-lg-4 col-xl-3 information">
                    <div className="info-wrapper">
                    {showContract ?
                      this.renderContract(contract, subscription)
                    :
                    user.hasSubscription && legacy ?
                      <>
                        { legacy.is_on_trial && 
                            <p>{gettext("Trial subscription")}. {gettext("Expires")}: {moment(legacy.active_until).format("D. M. YYYY")}</p>
                        }
                        { (legacy.is_on_trial || legacy.active) && legacy.plan &&
                          <p>
                              { legacy.plan.name } ({ parseFloat(legacy.plan.amount) } { legacy.plan.currency })
                          </p>
                        }
                        { !legacy.active && moment(legacy.active_until) > moment() &&
                            <p>{gettext("Expires")}: {moment(legacy.active_until).format("D. M. YYYY")}</p>
                        }
                        { (legacy.active && !legacy.cancelled ) &&
                            <>
                                <p>{gettext("Next renewal")}: {moment(legacy.active_until).format("D. M. YYYY")}</p>
                                <button className="btn" onClick={this.cancelSubscription}>{gettext("Stop renewal")}</button>
                            </>
                        }
                        { (legacy.cancelled ) &&
                            <p>{gettext("Subscription is cancelled and expires")}: {moment(legacy.active_until).format("D. M. YYYY")}</p>
                        }
                        <div>{ this.getPaymentMethod(subscription) }</div>
                        <button className="btn mt-5" onClick={() => this.props.dispatch(openModal("modal-subscription"))}>{gettext('Update credit card')}</button>

                      </>
                    :
                      <>
                        <p>{gettext("No active subscription")}</p>
                        <button className="btn buy-button btn-buy" onClick={() => this.props.dispatch(openModal("modal-subscription"))}>{gettext("Buy subscription")}</button>
                      </>
                    }
                    </div>
                </div>

                <div className="col-16 col-md-6 col-lg-4 col-xl-5 options">
                    <div className="info-wrapper">
                    { showContract && subscription.contract && (subscription.contract.billingRuns.length > 0 || subscription.contract.live) &&
                        <>
                          <h3>{gettext("Transactions")}</h3>
                          <div>
                            <div className="form-container">
                              { this.renderBillingRunsTable(subscription.contract.billingRuns)}
                            </div>
                          </div>
                        </>
                    }
                    { showContract && legacyHistory &&
                        <>
                          <h3 className="mt-4">{gettext("Earlier payments")}</h3>
                          <p className="earlier-payments-note">{gettext("Payments made before your subscription was moved to the new system.")}</p>
                          <div>
                            <div className="form-container">
                              { this.renderBillingLogsTable(subscription.data.billing_logs)}
                            </div>
                          </div>
                        </>
                    }
                    { !showContract && subscription.data && subscription.data.customer && 
                        <>
                          <h3>{gettext("Transactions")}</h3>
                          <div>
                            <div className="form-container">
                              { this.renderBillingLogsTable(subscription.data.billing_logs)}
                            </div>
                          </div>
                        </>
                        }
                    </div>
                </div>
              </div>
            </>

        )

    }


}

export default Subscription;
